console.log("global");
jQuery(document).ready(function ($) {
    // Function to handle Footer accordion behavior
    function handleAccordion() {
        $('.menu-roofing-services-container, .menu-quick-links-container, .site-footerInfo').hide();
        $('.menu-roofing-services-container, .menu-quick-links-container, .site-footerInfo').first().slideDown();
        $('#nav_menu-2 .footer-title, #nav_menu-3 .footer-title, #block-2 .footer-title').first().addClass('active-legend');

        $('#nav_menu-2 .footer-title, #nav_menu-3 .footer-title, #block-2 .footer-title').click(function(){
        $('#nav_menu-2 .footer-title, #nav_menu-3 .footer-title, #block-2 .footer-title').not(this).removeClass('active-legend').next('.menu-roofing-services-container, .menu-quick-links-container, .site-footerInfo').slideUp();
        $(this).toggleClass('active-legend');
        $(this).next('.menu-roofing-services-container, .menu-quick-links-container, .site-footerInfo').slideToggle();
        });
    }
    // Check window width and execute accordion behavior only for small screens
    if ($(window).width() < 768) {
        handleAccordion();
    }

// Function to handle Scroll Top Functionality
    // hide #back-top first
    $("#back-top").hide();

    // fade in #back-top
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                $('#back-top').fadeIn();
            } else {
                $('#back-top').fadeOut();
            }
        });

        // scroll body to 0px on click
        $('#back-top a').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });

    // Initialize the slick slider only if the element exists
    if ($('#blue-crews-reviews').length) {
        $('#blue-crews-reviews').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            infinite: true,
            lazyLoad: 'progressive',
            speed: 800,
            arrows: true,
            centerMode: false,
            adaptiveHeight: true,
            centerPadding: '0px',
            prevArrow: '<div class="prevNav"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_10708_4678)"> <circle cx="26" cy="26" r="26" transform="matrix(-1 0 0 1 52 0)" fill="#1B8BFA"/> <circle class="prev-icon-verlay" cx="26" cy="26" r="26" transform="matrix(-1 0 0 1 12 40)" fill="#03214F"/> <path d="M25.0785 18L27.0971 19.8659L21.4805 25.1732H35.9167V27.8269H21.4805L27.0971 33.1342L25.0785 35L16.0833 26.5L25.0785 18Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_10708_4678"> <rect width="52" height="52" rx="26" transform="matrix(-1 0 0 1 52 0)" fill="white"/> </clipPath> </defs> </svg></div>',
            nextArrow: '<div class="nextNav"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_10708_4679)"> <circle cx="26" cy="26" r="26" fill="#1B8BFA"/> <circle class="next-icon-verlay" cx="66" cy="66" r="26" fill="#03214F"/> <path d="M26.9216 18L24.903 19.8659L30.5195 25.1732H16.0834V27.8269H30.5195L24.903 33.1342L26.9216 35L35.9167 26.5L26.9216 18Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_10708_4679"> <rect width="52" height="52" rx="26" fill="white"/> </clipPath> </defs> </svg></div>',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        adaptiveHeight: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    // Initialize the Roofing Project slick slider only if the element exists
    if ($('.projects-carousel-wrap').length) {
        $('.projects-carousel-wrap').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            infinite: true,
            speed: 1300,
            arrows: true,
            centerMode: false,
            centerPadding: '0px',
            prevArrow: '<div class="prevNav"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_10708_4678)"> <circle cx="26" cy="26" r="26" transform="matrix(-1 0 0 1 52 0)" fill="#1B8BFA"/> <circle class="prev-icon-verlay" cx="26" cy="26" r="26" transform="matrix(-1 0 0 1 12 40)" fill="#03214F"/> <path d="M25.0785 18L27.0971 19.8659L21.4805 25.1732H35.9167V27.8269H21.4805L27.0971 33.1342L25.0785 35L16.0833 26.5L25.0785 18Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_10708_4678"> <rect width="52" height="52" rx="26" transform="matrix(-1 0 0 1 52 0)" fill="white"/> </clipPath> </defs> </svg></div>',
            nextArrow: '<div class="nextNav"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_10708_4679)"> <circle cx="26" cy="26" r="26" fill="#1B8BFA"/> <circle class="next-icon-verlay" cx="66" cy="66" r="26" fill="#03214F"/> <path d="M26.9216 18L24.903 19.8659L30.5195 25.1732H16.0834V27.8269H30.5195L24.903 33.1342L26.9216 35L35.9167 26.5L26.9216 18Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_10708_4679"> <rect width="52" height="52" rx="26" fill="white"/> </clipPath> </defs> </svg></div>',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 2,
                        adaptiveHeight: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 778,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    // Initialize the Tabs slick slider only if the element exists
    if ($('.tabs-slider').length) {
        $('.tabs-slider').slick({
            centerMode: true,
            centerPadding: '25%',
            slidesToShow: 1,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
            infinite: true,
            speed: 500,
            appendArrows: '.tabs-slider-nav',
            prevArrow: '<div class="prevNav"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"> <g clip-path="url(#clip0_36197_680)"> <circle cx="25" cy="25" r="25" transform="matrix(-1 0 0 1 50 0)" fill="#5B6B86"/> <path d="M25.6172 17L27.5509 18.7561L22.1704 23.7512H32.9999V26.2488H22.1704L27.5509 31.244L25.6172 33L17 25L25.6172 17Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_36197_680"> <rect width="50" height="50" rx="25" transform="matrix(-1 0 0 1 50 0)" fill="white"/> </clipPath> </defs> </svg></div>',
            nextArrow: '<div class="nextNav"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"> <g clip-path="url(#clip0_36197_687)"> <circle cx="25" cy="25" r="25" fill="#5B6B86"/> <path d="M24.3828 17L22.449 18.7561L27.8295 23.7512H17V26.2488H27.8295L22.449 31.244L24.3828 33L33 25L24.3828 17Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_36197_687"> <rect width="50" height="50" rx="25" fill="white"/> </clipPath> </defs> </svg></div>',
        });

        // Tab click: go to corresponding slide
        $('.tab-btn').on('click', function() {
            let index = $(this).data('slide');
            $('.tabs-slider').slick('slickGoTo', index);
            $('.tab-btn').removeClass('active');
            $(this).addClass('active');
        });

        // On slide change, update active tab
        $('.tabs-slider').on('afterChange', function(event, slick, currentSlide) {
            $('.tab-btn').removeClass('active');
            $('.tab-btn[data-slide="' + currentSlide + '"]').addClass('active');
        });
    }

    // Check if Instagram feed exists and has images
    const instagramFeed = $('#sb_instagram2');

    // Check if Instagram feed exists and has images
    if (instagramFeed.length && instagramFeed.find('#sbi_images2').length) {
        const checkInterval = setInterval(function () {
            const imagesLoaded = instagramFeed.find('.sbi_item').length > 0;
            
            if (imagesLoaded) {
                // Clear the interval once images are loaded
                clearInterval(checkInterval);
                
                // Initialize the Slick slider
                $('#sbi_images2').slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    autoplay: false,
                    infinite: true,
                    lazyLoad: 'progressive',
                    speed: 800,
                    arrows: true,
                    centerMode: false,
                    centerPadding: '0px',
                    prevArrow: '<div class="prevNav"><svg width="39" height="81" viewBox="0 0 39 81" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="Feed Arrow" opacity="0.8"> <circle id="Ellipse 7" cx="40.5" cy="40.5" r="40.5" transform="matrix(-1 0 0 1 39 0)" fill="#15181E"/> <path id="Vector" opacity="0.7" d="M18.9796 51C19.3743 50.9999 19.7601 50.8827 20.0882 50.6632C20.4164 50.4437 20.6721 50.1318 20.8231 49.7668C20.9742 49.4019 21.0137 49.0003 20.9367 48.6129C20.8597 48.2254 20.6697 47.8695 20.3907 47.5902L13.8184 41.0123L20.3907 34.4344C20.5813 34.2501 20.7334 34.0297 20.838 33.786C20.9426 33.5423 20.9976 33.2801 20.9999 33.0149C21.0022 32.7497 20.9517 32.4866 20.8514 32.2411C20.751 31.9957 20.6028 31.7726 20.4154 31.5851C20.228 31.3975 20.0052 31.2492 19.7599 31.1487C19.5146 31.0483 19.2518 30.9978 18.9868 31.0001C18.7217 31.0024 18.4598 31.0575 18.2163 31.1622C17.9728 31.2669 17.7526 31.419 17.5685 31.6098L9.58487 39.6C9.39945 39.7854 9.25237 40.0056 9.15201 40.2479C9.05165 40.4902 9 40.75 9 41.0123C9 41.2746 9.05165 41.5343 9.15201 41.7767C9.25237 42.019 9.39945 42.2391 9.58487 42.4245L17.5685 50.4147C17.7535 50.6005 17.9735 50.7479 18.2157 50.8483C18.4578 50.9488 18.7174 51.0003 18.9796 51Z" fill="white"/> </g> </svg></div>',
                    nextArrow: '<div class="nextNav"><svg width="40" height="81" viewBox="0 0 40 81" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="Feed Arrow" opacity="0.8"> <circle id="Ellipse 7" cx="40.5" cy="40.5" r="40.5" fill="#15181E"/> <path id="Vector" opacity="0.7" d="M20.0204 51C19.6257 50.9999 19.2399 50.8827 18.9118 50.6632C18.5836 50.4437 18.3279 50.1318 18.1769 49.7668C18.0258 49.4019 17.9863 49.0003 18.0633 48.6129C18.1403 48.2254 18.3303 47.8695 18.6093 47.5902L25.1816 41.0123L18.6093 34.4344C18.4187 34.2501 18.2666 34.0297 18.162 33.786C18.0574 33.5423 18.0024 33.2801 18.0001 33.0149C17.9978 32.7497 18.0483 32.4866 18.1486 32.2411C18.249 31.9957 18.3972 31.7726 18.5846 31.5851C18.772 31.3975 18.9948 31.2492 19.2401 31.1487C19.4854 31.0483 19.7482 30.9978 20.0132 31.0001C20.2783 31.0024 20.5402 31.0575 20.7837 31.1622C21.0272 31.2669 21.2474 31.419 21.4315 31.6098L29.4151 39.6C29.6005 39.7854 29.7476 40.0056 29.848 40.2479C29.9483 40.4902 30 40.75 30 41.0123C30 41.2746 29.9483 41.5343 29.848 41.7767C29.7476 42.019 29.6005 42.2391 29.4151 42.4245L21.4315 50.4147C21.2465 50.6005 21.0265 50.7479 20.7843 50.8483C20.5422 50.9488 20.2826 51.0003 20.0204 51Z" fill="white"/> </g> </svg></div>',
                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                slidesToShow: 5,
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 641,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });
            }
        });
    }
});

// Function to handle Mobile Menu
document.addEventListener("DOMContentLoaded", function() {
    const toggleButton = document.querySelector('.humberger-menu');
    const closeButton = document.querySelector('.humberger-menu-close');
    const mobileMenu = document.querySelector('.mobileMenu');

    // Function to toggle mobile menu visibility
    function toggleMobileMenu() {
        mobileMenu.classList.toggle('active');
    }

    // Function to close mobile menu
    function closeMobileMenu() {
        mobileMenu.classList.remove('active');
    }

    // Toggle mobile menu on click of toggle button
    toggleButton.addEventListener('click', function() {
        toggleMobileMenu();
    });

    // Close mobile menu on click of close button
    closeButton.addEventListener('click', function() {
        closeMobileMenu();
    });

    // Close mobile menu when a menu item is clicked
    const menuItems = document.querySelectorAll('.mobileMenu a');
    menuItems.forEach(function(item) {
        item.addEventListener('click', function() {
            closeMobileMenu();
        });
    });

    // Close mobile menu when anywhere else on the screen is clicked
    window.addEventListener('click', function(event) {
        if (!mobileMenu.contains(event.target) && !toggleButton.contains(event.target)) {
            closeMobileMenu();
        }
    });
});


//This Function for FAQs divided into two columns
document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".faqs-two-columns");
    if (container) { // Check if the container exists
        const faqs = Array.from(container.querySelectorAll(".wp-block-uagb-faq-child"));

        // Create two column wrappers
        const col1 = document.createElement("div");
        const col2 = document.createElement("div");
        col1.classList.add("faq-column");
        col2.classList.add("faq-column");

        // Divide the FAQs roughly in half
        const half = Math.ceil(faqs.length / 2);
        faqs.forEach((faq, i) => {
            if (i < half) {
                col1.appendChild(faq);
            } else {
                col2.appendChild(faq);
            }
        });

        // Clear the original container and add the two columns
        container.innerHTML = '';
        container.appendChild(col1);
        container.appendChild(col2);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Read More popup logic
    const readMoreLinks = document.querySelectorAll('.read-more');
    const popup = document.getElementById('review-popup');
    const popupText = document.getElementById('popup-review-text');
    const closeBtn = document.querySelector('.popup-close');
    const overlay = document.querySelector('.popup-overlay');

    // Only add event listeners if elements are found
    if (readMoreLinks.length) {
        readMoreLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const fullText = this.getAttribute('data-full');
                if (popupText) {
                    popupText.textContent = fullText;
                }
                if (popup) {
                    popup.style.display = 'block';
                }
            });
        });
    }

    if (closeBtn && overlay) {
        [closeBtn, overlay].forEach(el => {
            el.addEventListener('click', () => {
                if (popup) {
                    popup.style.display = 'none';
                }
            });
        });
    }

});

document.addEventListener('DOMContentLoaded', function () {
    // Open the gallery in a popup when an image is clicked
    document.querySelectorAll('.open-gallery').forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            
            // Get gallery images from data-gallery attribute
            const images = JSON.parse(this.getAttribute('data-gallery'));

            if (images && images.length) {
                // Create gallery HTML structure
                let galleryHtml = '';
                images.forEach(function (img) {
                    galleryHtml += `
                        <div class="slick-slide">
                            <img src="${img.url}" alt="${img.alt || ''}" />
                        </div>
                    `;
                });

                // Append gallery HTML to the popup
                const projectGallery = document.querySelector('.project-gallery');
                const slickGallery = projectGallery.querySelector('.slick-gallery');

                // Clear the previous gallery images from the popup
                slickGallery.innerHTML = '';  // This ensures the gallery is cleared before adding new images.

                // Insert the new gallery HTML into the popup
                slickGallery.innerHTML = galleryHtml;

                // Show the popup by adding the "project-gallery-visible" class
                projectGallery.classList.add('project-gallery-visible');
                console.log("Class 'project-gallery-visible' added to project-gallery");

                // Initialize Slick Slider inside the popup after images are loaded
                jQuery(document).ready(function ($) {
                    // Destroy the previous Slick Slider instance if it exists
                    if ($('.slick-gallery').hasClass('slick-initialized')) {
                        $('.slick-gallery').slick('unslick');
                    }

                    // Reinitialize Slick Slider with the new images
                    $('.slick-gallery').slick({
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                        adaptiveHeight: true,
                        centerMode: true,
                        centerPadding: '0px',
                        prevArrow: '<div class="prevNav"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_10708_4678)"> <circle cx="26" cy="26" r="26" transform="matrix(-1 0 0 1 52 0)" fill="#1B8BFA"/> <circle cx="26" cy="26" r="26" transform="matrix(-1 0 0 1 12 40)" fill="#03214F"/> <path d="M25.0785 18L27.0971 19.8659L21.4805 25.1732H35.9167V27.8269H21.4805L27.0971 33.1342L25.0785 35L16.0833 26.5L25.0785 18Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_10708_4678"> <rect width="52" height="52" rx="26" transform="matrix(-1 0 0 1 52 0)" fill="white"/> </clipPath> </defs> </svg></div>',
                        nextArrow: '<div class="nextNav"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_10708_4679)"> <circle cx="26" cy="26" r="26" fill="#1B8BFA"/> <circle cx="66" cy="66" r="26" fill="#03214F"/> <path d="M26.9216 18L24.903 19.8659L30.5195 25.1732H16.0834V27.8269H30.5195L24.903 33.1342L26.9216 35L35.9167 26.5L26.9216 18Z" fill="#FCFDFF"/> </g> <defs> <clipPath id="clip0_10708_4679"> <rect width="52" height="52" rx="26" fill="white"/> </clipPath> </defs> </svg></div>',
                        fades: true,
                        speed: 800,
                        lazyLoad: 'progressive',
                    });
                });
            }
        });
    });

    // Close the gallery popup when the close button is clicked
    const projectGallery = document.querySelector('.project-gallery');
    if (projectGallery) {
        // Close when the close button is clicked
        projectGallery.querySelector('.popup-close').addEventListener('click', function () {
            // Remove the visible class to hide the popup
            projectGallery.classList.remove('project-gallery-visible');
            console.log("Class 'project-gallery-visible' removed from project-gallery");

            // Destroy Slick Slider instance and clear the gallery content
            jQuery(document).ready(function ($) {
                if ($('.slick-gallery').hasClass('slick-initialized')) {
                    $('.slick-gallery').slick('unslick');  // Destroy Slick Slider
                }
                $('.slick-gallery').empty();  // Clear the gallery content
            });
        });
    }
});

// Scroll to #news-tips after FacetWP AJAX finishes
(function($) {
    $(document).on('facetwp-loaded', function() {
        let target = $('#news-tips');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 50 // adjust offset as needed
            }, 500);
        }
    });
})(jQuery);



// FAQs divided into two columns (only if FAQ section exists)
function setupFaqTwoColumn(container) {
    if (!container) return;

    const faqs = Array.from(container.querySelectorAll(".wp-block-uagb-faq-child"));

    if (faqs.length === 0) return;

    const col1 = document.createElement("div");
    const col2 = document.createElement("div");
    col1.classList.add("faq-column");
    col2.classList.add("faq-column");

    const half = Math.ceil(faqs.length / 2);
    faqs.forEach((faq, i) => {
        if (i < half) {
            col1.appendChild(faq);
        } else {
            col2.appendChild(faq);
        }
    });

    container.innerHTML = '';
    container.appendChild(col1);
    container.appendChild(col2);
}

// Run on DOM load
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".faqs-two-columns").forEach(setupFaqTwoColumn);
});

// Optional: Run on tab change
document.querySelectorAll('.your-tab-button-class').forEach(tab => {
    tab.addEventListener('click', function () {
        // Give time for tab content to appear (e.g., if it's loaded dynamically)
        setTimeout(() => {
            document.querySelectorAll(".faqs-two-columns").forEach(container => {
                // Re-run only if not already split
                if (!container.querySelector(".faq-column")) {
                    setupFaqTwoColumn(container);
                }
            });
        }, 100); // adjust delay as needed
    });
});

// Estimate Popup Functionality
document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('estimate-popup');
    if (!popup) return;

    const closeBtn = popup.querySelector('.estimate-popup-close');
    const triggers = document.querySelectorAll('.get-estimate-popup');

    // Function to open popup
    function openPopup() {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Function to close popup
    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    // Add click event to all triggers
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            openPopup();
        });
    });

    // Close popup when clicking the close button
    closeBtn.addEventListener('click', closePopup);

    // Close popup when clicking outside
    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            closePopup();
        }
    });

    // Close popup when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });
});